<template>
  <div>
    <credit-card-unblock-modal
        v-if="visible"
        :card-id="Number(cardId)"
        :contract-id="Number(contractId)"
        :visible="visible"
        is-mobile-app
        @onModalClosed="onModalClosed"
    />
    <credit-card-action-done v-else />
  </div>
</template>

<script>
import CreditCardActionDone from '@credit-card/views/mobile-standalone/CreditCardActionDone.vue'
import CreditCardUnblockModal from '@credit-card/components/modals/CreditCardUnblockModal.vue'

export default {
  name: 'credit-card-unblock-page',
  components: { CreditCardUnblockModal, CreditCardActionDone },
  props: {
    cardId: {
      type: String,
      required: true
    },
    contractId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      visible: true
    }
  },
  methods: {
    onModalClosed () {
      this.visible = false
    }
  }
}
</script>
